import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=fd89e7f0&"
import script from "./Module.vue?vue&type=script&lang=js&"
export * from "./Module.vue?vue&type=script&lang=js&"
import style0 from "./Module.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports